<div
  class="w-full overflow-hidden bg-black/30"
  [class]="[colorClass(), sizeClass()]"
>
  <!-- scaleX under a CSS transition runs on the compositor, so the fill keeps moving through main-thread stalls. -->
  <div
    class="relative h-full origin-left overflow-hidden bg-current transition-transform duration-400 ease-out bar-progress-fill"
    [style.transform]="`scaleX(${fillScale()})`"
  >
    @if (shimmer()) {
      <div
        appShimmer
        class="h-full w-1/3 bg-linear-to-r from-transparent via-white/40 to-transparent"
      ></div>
    }
  </div>
</div>

<progress class="sr-only" [value]="value()" [max]="max()"></progress>

<span
  class="absolute inset-0 flex items-center justify-center text-xs text-shadow-black pointer-events-none tabular-nums"
>
  <ng-content></ng-content>
</span>
